import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ agents }) => {
  const totalAgents = agents?.length;
  const activeAgents = agents?.filter(agent => agent?.isActive)?.length;
  const totalChats = agents?.reduce((sum, agent) => sum + agent?.chatCount, 0);
  const totalMessages = agents?.reduce((sum, agent) => sum + agent?.messageCount, 0);

  const stats = [
    {
      label: 'Gesamt Agenten',
      value: totalAgents,
      icon: 'Bot',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Aktive Agenten',
      value: activeAgents,
      icon: 'Activity',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Gesamt Chats',
      value: totalChats?.toLocaleString('de-DE'),
      icon: 'MessageSquare',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      label: 'Gesamt Nachrichten',
      value: totalMessages?.toLocaleString('de-DE'),
      icon: 'MessageCircle',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {stats?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className={`w-10 h-10 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">{stat?.label}</p>
              <p className="text-xl font-semibold text-foreground">{stat?.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;